import { mixpanelTrackAction } from "./tracking";
import { onStartMainSurvey } from "./survey/onStartMainSurvey";
import { onCompleteMainSurvey } from "./survey/onCompleteMainSurvey";

import { GoToPageOptions } from "../goto/pageSet";
import { onStartPaymentSurvey } from "./survey/onStartPaymentSurvey";
import { onCompletePaymentSurvey } from "./survey/onCompletePaymentSurvey";
import { PageList, PageSet } from "../types";

export type ActionHandlerParams = {
  params: JsonObject;
  pageSet: PageSet;
  page: PageList[0];
} & GoToPageOptions;

export type ActionHandler = (params: ActionHandlerParams) => void;

const ACTIONS = {
  TRACK: mixpanelTrackAction,
  ON_START_MAIN_SURVEY: onStartMainSurvey,
  ON_COMPLETE_MAIN_SURVEY: onCompleteMainSurvey,
  ON_START_PAYMENT_SURVEY: onStartPaymentSurvey,
  ON_COMPLETE_PAYMENT_SURVEY: onCompletePaymentSurvey,
};

export default ACTIONS;
